<template>
  <div class="big_box" style="background-color: #fff">

      <div class="nav">
<!--        <div class="btn" @click="bk()">< 返回</div>-->
<!--        <span class="el-dropdown-link c1">-->
<!--             业务员排行榜-->
<!--        </span>-->
        <div style="width: 100%;height: 50px;background-color: #fff;line-height: 50px;text-align: center;position: relative;border-bottom: 1px solid #e8e8e8">
          <div style="color: #4D586D;position: relative">业务员排行榜
            <div class="grid-content bg-purple " style="position: absolute;left: 10px;top: 0px;color: #FF9901">
              <span class="el-icon-arrow-left" @click="bk()">返回</span>
            </div>
          </div>
        </div>
      </div>

    <div style="text-align: center;padding: 10px 0px;">
      <el-radio-group size="mini" v-model="type" fill="#FF9901">
        <el-radio-button label="quarter">按季度</el-radio-button>
        <el-radio-button label="month">按月份</el-radio-button>
      </el-radio-group>
    </div>

      <div v-if="type=='quarter'">
        <lo-quarter :ats="tenant_id" :ats1="dataStr"  :ats2="type" :ats3="year"></lo-quarter>
      </div>
      <div v-else-if="type=='month'">
        <lo-month :ats="tenant_id" :ats1="month"  :ats2="type" :ats3="year"></lo-month>
      </div>


  </div>
</template>

<script>
import loMonth from "./loMonth";
import loQuarter from "./loQuarter";
export default {
  name: "login7",
  components: {loMonth,loQuarter},
  data(){
    return{
        tenant_id:'1472813523',
        dataStr:'3',
        type: "quarter",
        year:'2020',
        month:'',

    }
  },
  methods:{
    bk(){
      this.$router.push({path:'/reportIndex'})
    },
    fc(){
      var date = new Date();
      var m = date.getMonth()+1;
      this.month=m
      console.log(this.month)
    }
  },
  created() {
    this.fc();
  }
}
</script>

<style>

  .btn{
    color: orange;
  }

  .el-card__body {
    padding: 0px;
  }
  /*.nav{*/
  /*  width: 100%;*/
  /*  height: 50px;*/
  /*  background-color: white;*/
  /*  margin-top: 10px;*/
  /*  margin-bottom: -45px;*/
  /*  padding-left: 10px;*/
  /*}*/
  .c1{
    margin-left: 130px;
    margin-top: -15px;
    position: absolute;
    font-size: 18px;
  }
  button{
    background-color: #FF9901;
    color: white;
    border: none;
  }

</style>



// WEBPACK FOOTER //
// src/pages/gkReport/Salesman.vue